import React from "react";

const colors = [
  "rgba(44, 91, 71, 0.9)",
  "rgba(44, 91, 71, 0.8)",
  "rgba(44, 91, 71, 0.6)",
  "rgba(44, 91, 71, 0.4)",
];

const LocationTabs = ({ locations }) => (
  <div className="location-tabs">
    {locations.map((location, index) => (
      <div
        key={index}
        className={
          colors[0] === colors[index % colors.length]
            ? "location-tab"
            : "location-tab-others"
        }
        style={{
          backgroundColor: colors[index % colors.length],
          marginLeft: "-10px",
        }}
      >
        {location}
      </div>
    ))}
  </div>
);

export default LocationTabs;
